//React
//Components
import {
  AlphaNumericInput,
  Button,
  Card,
  Chart,
  DashboardHeader,
  DashboardScreen,
  Dropdown,
  EmailRegistrationModal,
  FlexBox,
  Input,
  Radio,
  RupeeAmount,
  Screen,
  TitleBlock,
  TranslatedString,
  Image,
} from "components";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import ROUTE_PATH from "Routes/paths";
import {
  CreateApplicationApi,
  registerClientApi,
  setGeneralDetails,
  useGeneralDetails,
  useGetUserDetailsApiDetails,
  useRegisterClientApiDetails,
} from "Slices";
//Utils
import { ChangeHistory, EventManager, EventNames, validateEmail } from "utils";
//Styles
import "./styles.scss";
//Assets
import JavaIcon from "assets/icons/java.png";
import AndroidIcon from "assets/icons/android.svg";
import AppleIcon from "assets/icons/apple.svg";
import RestApiIcon from "assets/icons/rest-api.svg";
//Library
import cx from "classnames";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const Landing = () => {
  //Dispatch
  const dispatch = useDispatch();
  const [graphType, setGraphType] = useState("Chart View");
  const [dataSelector, setDataSelector] = useState("Total");
  const [applicationName, setApplicationName] = useState("");
  const [redirectionUrl, setRedirectionUrl] = useState("");
  const [activeApplicationType, setActiveApplicationType] = useState("");

  //Slices
  const userDetails = useGetUserDetailsApiDetails();

  const createApplication = () => {
    dispatch(
      CreateApplicationApi({
        appName: applicationName,
        platform: activeApplicationType,
        organizationId: localStorage.getItem("organisationID"),
        type: "UAT",
        callback: setApplicationRoute,
      })
    );
  };

  const routeToApplicationDetails = (activeApplicationID) => {
    setGeneralDetails({
      activeApplicationID,
    });
    ChangeHistory("push", ROUTE_PATH.DASHBOARD.APPLICATION_DETAILS);
  };

  const setApplicationRoute = (data: any) => {
    if (data.applicationId) {
      routeToApplicationDetails(data?.applicationId);
    }
  };

  useEffect(() => {
    setGeneralDetails({
      activeSideMenuOption: "Application",
    });
  }, []);

  //Render UI
  const TopSection = <DashboardHeader title={"Create Application"} />;

  const FormSection = (
    <div className="form-section mr-t-40">
      <TitleBlock
        title={"Application Name"}
        titleClass="fs-16 font-heavy"
        className="animated fadeInUp delay-01s"
        content={
          <div className="w-50">
            <AlphaNumericInput
              value={applicationName}
              onChange={setApplicationName}
              className="br-9 fs-14"
              placeholder={"Application Name"}
            />
          </div>
        }
      />
      <TitleBlock
        title={""}
        titleClass="fs-16 font-heavy"
        className="animated fadeInUp delay-02s mr-t-40"
        content={
          <div className="grey-box br-9 pd-20 w-70">
            <p className="font-heavy fs-14">
              Improve your conversion with Login with WhatsApp SDKs
            </p>
            <p className="fs-12 mr-t-10">
              BharatPe saw 28% more sign-ups after integrating Login with
              WhatsApp Button. OTPless recommends integrating Login with
              WhatsApp button with SDKs which allows you to enable 2 Tap Login
              experience through few lines of code
            </p>
          </div>
        }
      />

      <TitleBlock
        title={"Choose your platform"}
        titleClass="fs-16 mr-t-40 font-heavy"
        className="animated fadeInUp delay-02s"
        content={
          <>
            <p className="fs-16 mr-t-10 fs-12">
              Build authentication with minimum backend code
            </p>

            <FlexBox
              justifyBetween
              className="mr-t-20 integration-flexbox w-70"
            >
              <Card
                className={cx(
                  activeApplicationType === "ANDROID" &&
                    "full-border theme-border scale-1_1",
                  "pd-0 w-30 animated fadeInLeft delay-03s text-center curs-point transition"
                )}
                onClick={() => {
                  setActiveApplicationType("ANDROID");
                }}
              >
                <div className="pd-20">
                  <Image src={AndroidIcon} />
                  <p className="mr-t-20 fs-16 font-heavy">Android</p>
                </div>
              </Card>
              <Card
                className={cx(
                  activeApplicationType === "IOS" &&
                    "full-border theme-border scale-1_1",
                  "pd-0 w-30 animated fadeInLeft delay-05s text-center curs-point transition"
                )}
                onClick={() => {
                  setActiveApplicationType("IOS");
                }}
              >
                <div className="pd-20">
                  <Image src={AppleIcon} />
                  <p className="mr-t-20 fs-16 font-heavy">iOS</p>
                </div>
              </Card>
              <Card
                className={cx(
                  activeApplicationType === "Web" &&
                    "full-border theme-border scale-1_1",
                  "pd-0 w-30 animated fadeInLeft delay-01s text-center curs-point transition"
                )}
                onClick={() => {
                  setActiveApplicationType("Web");
                }}
              >
                <div className="pd-20">
                  <Image src={JavaIcon} />
                  <p className="mr-t-20 fs-16 font-heavy">Web</p>
                </div>
              </Card>
              {/* <Card
                className={cx(
                  activeApplicationType === "REST API" &&
                    "full-border theme-border scale-1_1",
                  "pd-0 w-20 animated fadeInLeft delay-05s text-center curs-point transition"
                )}
                onClick={() => {
                  setActiveApplicationType("REST API");
                }}
              >
                <div className="pd-20">
                  <Image src={RestApiIcon} />
                  <p className="mr-t-20 fs-16 font-heavy">Rest API</p>
                </div>
              </Card> */}
            </FlexBox>
          </>
        }
      />
      <Button
        text={"Create"}
        className="w-20 fs-14 mr-t-40 animated fadeInUp delay-05s"
        onClick={() => {
          createApplication();
        }}
      />
    </div>
  );
  //Return UI
  return (
    <DashboardScreen
      className="create-application-screen"
      hasSideMenu
      hasHeader
      screenAnimationClass="no-animation"
    >
      {TopSection}
      {FormSection}
    </DashboardScreen>
  );
};

export default Landing;
